<div class="row" *ngIf="branches?.length > 1">
  <div class="col-12">
    <div class="branch-container">
      <h3 class="section-title">Select Your Gym Branch</h3>

      <div class="branch-cards-wrapper">
        <mat-button-toggle-group
          [hideSingleSelectionIndicator]="true"
          [(ngModel)]="selectedBranchId"
          (change)="onBranchSelect($event.value)"
          class="branch-toggle-group"
          aria-label="Gym Branches"
        >
          <mat-button-toggle
            *ngFor="let branch of branches"
            [value]="branch._id"
            class="branch-option"
          >
            <div
              class="branch-content"
              style="width: 100%; display: flex; justify-content: space-between"
            >
              <mat-icon class="branch-icon">fitness_center</mat-icon>
              <span class="branch-name">{{ branch.subName }}</span>
              <div
                class="selection-indicator"
                *ngIf="selectedBranchId === branch._id"
              >
                <mat-icon class="selected-icon">check_circle</mat-icon>
              </div>
            </div>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </div>
</div>
